import React, { useState } from "react";
import { LuCirclePlus } from "react-icons/lu";
import { ClipLoader } from "react-spinners";

const UpdateButton = ({ loading, isEdit }) => {
  const [hover, setHover] = useState(false);

  return (
    <button
      type="submit"
      disabled={loading}
      className="update-btn"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {loading ? (
        <ClipLoader size={22} color={hover ? "#0579AA" : "#fff"} />
      ) : (
        <LuCirclePlus size={22} />
      )}
      {isEdit ? " Update" : " Add"}
    </button>
  );
};

export default UpdateButton;
